import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-center flex-wrap",
  style: {"gap":"5px"}
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "justify-start flex-wrap mb-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Detalhes do App", -1)
const _hoisted_5 = { class: "d-flex justify-space-between" }
const _hoisted_6 = { class: "title-prop" }
const _hoisted_7 = { class: "justify-start flex-wrap mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Versões Disponíveis", -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "text-center mt-2"
}
const _hoisted_12 = {
  key: 2,
  class: "text-center mt-2"
}

import { ref, watch, withDefaults, onMounted } from 'vue';
import { MoleculeModal, MoleculeListActions } from '@/components/molecules';
import { Application, ApplicationVersion, Company, Group, Licence, LicenceGroup, User } from '@/core/model';
import { create, update } from '@/core/service/UserService';

import { getAllCollaborator, getAll as groupAll } from '@/core/service/GroupService';
import { validateCPF, validateEmail } from '@/core/service/ValidateService';
import { Preloader } from '@/store';
import Swal from 'sweetalert2';
import {
  AtomInput,
  GroupIcon,
  AtomButton,
  SearchIcon,
  AtomCheckBox,
  AtomAccordion,
  AtomSelect,
} from '@/components/atoms';
import { computed } from 'vue';
import { Authentication } from '@/store';
import { IHeadersTable, IOptionsSelect } from '@/types';
import { getHeadquartersByUser, getSubsidiariesByHeadquartersId } from '@/core/service/CompanyService';
import { getAll } from '@/core/service/GroupService';
import { getAvailableToObtain, getLicenceAplication } from '@/core/service/LicenceService';
import { format } from 'date-fns';
import { createLicenseGroup } from '@/core/service/LicenceService';

interface IProps {
  showModal: boolean;
  application?: Application;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculePurchaseLicenseModal',
  props: {
    showModal: { type: Boolean, default: false },
    application: null
  },
  emits: ['onHandleClose', 'addGroup'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, application?: Application };

const optionsGroup = ref<IOptionsSelect[]>([]);
const group = ref<number>();




const image = computed(() => {
  return `${process.env.VUE_APP_API_URL_FILESYSTEM}${props.application?.logo_url}`;
});
function load() {
  getAvailableToObtain(
    props.application?.id as number,
    group.value as number,
    Authentication.getters.getUser.value.mkId as number
  ).then((resp) => {
    items.value = resp.data.map((f) => {
      return {
        id: f.id,
        version: f.application_version.version,
        so: `assets/os/${f.application_version.platform}.png`,
        expiration_dateFormat: format(new Date(f.expiration_date), 'dd/MM/yyyy'),
        number_of_uses_left: f.number_of_uses_left,
        number_of_uses: 0,
      };
    });
  });
}

const items = ref<Licence[]>([]);
const headers = ref<IHeadersTable[]>([
  { field: 'so', label: 'SO', type: 'image' },
  { field: 'version', label: 'Versão' },
  { field: 'expiration_dateFormat', label: 'Dt. Expiração' },
  { field: 'number_of_uses_left', label: 'Disponíveis' },
  { label: 'Ações', field: 'actions' },
]);

const disabledButton = computed(() => {
  return !group.value || items.value.filter((f) => (f.number_of_uses ?? 0) > 0).length == 0;
});
const groups = ref<Group[]>([]);
const search = ref<string>('');

const data = ref<User>({});
function loadGroup() {
  getAllCollaborator(Authentication.getters.getUser.value.mkId as number).then((f) => {
    optionsGroup.value = f.data.map((x) => {
      return { text: x.name, value: x.id };
    });
  });
}

async function handleAdd() {
  let results: any[] = [];
  let result;
  for (const it of items.value.filter((f) => f.number_of_uses != null && f.number_of_uses > 0)) {
    result = await createLicenseGroup({
      licence_id: it.id,
      group_id: group.value,
      collaborator_id: Authentication.getters.getUser.value.mkId,
      number_of_uses: it.number_of_uses,
    });
    results.push(result.success);
  }
  Swal.fire({
    icon: results.every((f) => !f) ? 'warning' : 'success',
    title: results.every((f) => !f) ? 'Atenção' : 'Sucesso',
    text: results.every((f) => !f)
      ? 'Não foi possivel adiquirir nenhuma licença, entre em contato com o suporte!'
      : results.every((f) => f)
      ? 'Todas as licenças selecionadas foram adiquiridas com sucesso!'
      : 'Algumas licenças foram adiquiridas, conferir na tela de licença grupo quaois foram adiquiridas com sucesso.',
  }).then(() => {
    emit('onHandleClose', false);
  });
}
function clear() {
  data.value = {};
  emit('onHandleClose', false);
}

watch(
  () => props.showModal,
  () => {
    if (props.showModal) {
      group.value = undefined;
      loadGroup();
    }
  }
);

watch(
  () => group.value,
  () => {
    load();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    width: "649px",
    onHandleConfirm: handleAdd,
    onHandleCancel: clear,
    icon: "ArchiveBookIcon",
    iconColor: "#5528B5",
    title: "Adquirir Licenças",
    show: __props.showModal,
    "btn-close-text": "Cancelar",
    "btn-confirm-text": "Adquirir",
    btnConfitmDisabled: _unref(disabledButton)
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_avatar, {
                color: "grey",
                size: "36",
                rounded: "0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    cover: "",
                    src: _unref(image)
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createElementVNode("p", _hoisted_6, _toDisplayString(props.application?.name), 1)
            ])
          ]),
          _createVNode(_component_v_divider),
          _createVNode(_unref(AtomSelect), {
            modelValue: group.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((group).value = $event)),
            placeholder: "Selecione um grupo",
            options: optionsGroup.value,
            label: "Selecionar Grupo *",
            hasError: !group.value,
            required: "",
            msgError: "Campo obrigatório"
          }, null, 8, ["modelValue", "options", "hasError"]),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            (items.value.length && group.value)
              ? (_openBlock(), _createBlock(_unref(MoleculeListActions), {
                  key: 0,
                  headers: headers.value,
                  items: items.value
                }, {
                  actions: _withCtx(({ data }) => [
                    _createVNode(_unref(AtomInput), {
                      modelValue: data.number_of_uses,
                      "onUpdate:modelValue": ($event: any) => ((data.number_of_uses) = $event),
                      "prepend-icon": "",
                      "append-icon": "",
                      "max-width": '142px',
                      type: "number",
                      min: "0",
                      max: data.number_of_uses_left,
                      height: "32px",
                      alignInput: "center"
                    }, {
                      appendIcon: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (
                        data.number_of_uses + 1 > data.number_of_uses_left
                          ? data.number_of_uses_left
                          : (data.number_of_uses += 1)
                      ), ["prevent"])
                        }, " + ", 8, _hoisted_9)
                      ]),
                      prependIcon: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (data.number_of_uses > 0 ? (data.number_of_uses -= 1) : null), ["prevent"])
                        }, " - ", 8, _hoisted_10)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "max"])
                  ]),
                  _: 1
                }, 8, ["headers", "items"]))
              : (!group.value)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_11, "Selecione um grupo para acharmos as licenças"))
                : (_openBlock(), _createElementBlock("h5", _hoisted_12, "Não há licenças para serem adquiridas"))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show", "btnConfitmDisabled"]))
}
}

})